// The patient's telemed page (/visit) boots on its own: no app shell, no Sentry, no telemetry.
// Kept tiny because src/index.js imports it eagerly to make that decision before anything starts.
export const isTelemedVisitPath = (pathname) => {
  const path = String(pathname || "");
  return path === "/visit" || path.startsWith("/visit/");
};

export const TELEMED_VISIT_PAGE = typeof window !== "undefined" && isTelemedVisitPath(window.location.pathname);
